module.exports = __webpack_public_path__ + "fa5b7d289b9de4c9e6a9a3bec6e744ea.svg";